/**
 * Precision and Rounding Core (Frontend)
 * Implements System-Wide precision rules preventing UI calculation drifts before they hit the API.
 */

// Global configuration standards mapped from the backend schema
export const CONFIG = {
  CURRENCY_DECIMALS: 2,
  QUANTITY_DECIMALS: 4,
  EXCHANGE_RATE_DECIMALS: 6
};

/**
 * Banker's Rounding (Round to nearest even)
 * Mirrors the exact logic on the server to prevent validation failures.
 * 
 * @param {number|string} num - The number to round
 * @param {number} decimalPlaces - Precision
 * @returns {number}
 */
export const bankersRound = (num, decimalPlaces) => {
  const d = decimalPlaces || 0;
  const m = Math.pow(10, d);
  const n = +(d ? Number(num) * m : Number(num)).toFixed(8);
  const i = Math.floor(n), f = n - i;
  const e = 1e-8;
  const r = (f > 0.5 - e && f < 0.5 + e) ?
              ((i % 2 === 0) ? i : i + 1) : Math.round(n);
  return Number((d ? r / m : r).toFixed(d));
};

/**
 * Round Currency sums (Total Amounts, Taxes, etc.) to exactly 2 decimals
 */
export const formatCurrency = (amount) => bankersRound(amount, CONFIG.CURRENCY_DECIMALS);

/**
 * Round Inventory Quantities (tons, kg, liters) to exactly 4 decimals
 */
export const formatQuantity = (amount) => bankersRound(amount, CONFIG.QUANTITY_DECIMALS);

/**
 * High-precision parsing wrapper for form inputs
 */
export const parseSafeFloat = (value, fallback = 0) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? fallback : parsed;
};
